import { useHistory, useParams } from "react-router-dom";
import { Button, Card, Grid, Toast, WhiteSpace, WingBlank } from "antd-mobile";
import React, { useCallback, useEffect, useState } from "react";
import instance from "../../../../util/axios";
import { Result } from "../../../../schema";

export default function OrderDetail() {
  const [data, setData] = useState<any[]>([]);
  const params = useParams<{
    uuid: string;
    tableName: string;
    name: string;
  }>();
  const history = useHistory();
  const load = useCallback(() => {
    instance
      .get<Result<any[]>>(
        `/erp/radOrder/orderDetailMobile?tableName=${params.tableName}&uuid=${params.uuid}`
      )
      .then((resp) => {
        if (resp.data.Status === "1") {
          setData(resp.data.Data);
        } else {
          Toast.fail(resp.data.Message);
        }
      });
  }, []);

  useEffect(() => {
    load();
  }, [load]);
  return (
    <>
      <WingBlank style={{ marginTop: 10, marginBottom: 5 }}>
        <span
          style={{
            marginTop: "5px",
            marginRight: "40px",
            fontSize: "inherit",
            color: "#1890ff",
          }}
          onClick={() => history.go(-1)}
        >
          返回
        </span>
        <span
          style={{
            marginTop: "5px",
            fontSize: "inherit",
            fontWeight: "bold",
            color: "#1890ff",
          }}
          onClick={() => history.go(-1)}
        >
          {params.name}
        </span>
      </WingBlank>
      {data.map((item) => (
        <WingBlank size="lg">
          <WhiteSpace size="lg" />
          <Card>
            <Card.Header title={item.formulaName} />
            <Card.Body>
              <Grid
                square={false}
                hasLine={false}
                data={[
                  {
                    text: item.radName,
                  },
                  {
                    text: item.model || "",
                  },
                  {
                    text: item.custom_text_1 || "",
                  },
                  {
                    text: item.centerSpacing || "",
                  },
                  {
                    text: item.pieces || "0",
                  },
                  {
                    text: item.custom_text_2 || "",
                  },
                  {
                    text: item.custom_text_3 || "",
                  },
                  {
                    text: item.custom_text_4 || "",
                  },
                  {
                    text: item.colorName || "",
                  },
                  {
                    text: item.waterFlowName || "",
                  },
                  {
                    text: item.caliberName || "",
                  },
                  {
                    text: item.custom_dropdown_1 || "",
                  },
                  {
                    text:
                      item.custom_dropdown_2 && item.custom_dropdown_2 == "1"
                        ? "防腐：是"
                        : "防腐：否",
                  },
                  {
                    text: item.isSpecials || "",
                  },
                  {
                    text: item.mainRemark || "",
                  },
                  {
                    text: "数量：" + item.quantity,
                  },
                ]}
                columnNum={2}
              />
            </Card.Body>
            <Card.Footer
              content={
                <>
                  <table style={{ width: "100%" }}>
                    <tr>
                      <td>
                        <Button
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            history.push(
                              `/erp/order/image/${item.attachmentId}/${item.formulaName}`
                            );
                          }}
                        >
                          查看图纸
                        </Button>
                      </td>
                    </tr>
                  </table>
                </>
              }
            />
          </Card>
          <WhiteSpace size="lg" />
        </WingBlank>
      ))}
    </>
  );
}
